<template>
  <div class="activitiesView">
    <activityStaff/>
  </div>
</template>

<script>
import activityStaff from '../../components/staff/activityStaff.vue';
export default {
name:'activitiesView',
components:{activityStaff}
}
</script>

<style>

</style>